import styled from 'styled-components';
import Dropdown from 'components/dropdown';
import DropdownContent from 'components/dropdown/partials/DropdownContent';
import format from 'helpers/translations';
import type ISelect from '../shared/types/select';
import SelectButton from './SelectButton';
import SelectOption from './SelectOption';
import SelectProvider from './SelectProvider';

const OptionsList = styled.ul`
    display: flex;
    flex-direction: column;
    padding-inline-start: 0;
`;

export default function CustomSelect({
    value,
    options,
    placeholderText,
    disabled,
    className,
    size = 'md',
    dropdownContentProps,
    label,
    isInvalid,
    helperText,
    ...restProps
}: ISelect) {
    return (
        <Dropdown
            disabled={disabled}
            trigger={
                <SelectButton
                    size={size}
                    className={className}
                    label={label}
                    isInvalid={isInvalid}
                    helperText={helperText}
                >
                    {format(value?.label || placeholderText)}
                </SelectButton>
            }
        >
            <DropdownContent {...dropdownContentProps}>
                <SelectProvider {...restProps}>
                    <OptionsList>
                        {options.map((option) => (
                            <SelectOption key={option.value} value={option}>
                                {format(option.label)}
                            </SelectOption>
                        ))}
                    </OptionsList>
                </SelectProvider>
            </DropdownContent>
        </Dropdown>
    );
}
